import { Category } from "@/models/categories.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import EquipmentList from "./parts/CategoryEquipmentsBoard/parts/EquipmentList/index.vue";
@Component({
  components: {
    EquipmentList,
  },
})
export default class EquipmentCategories extends Vue {
  @Prop() categories!: Category[];
  @Prop() constructorFilter!: string;
}
